import React from 'react';
import ImageUploader from './ImageUploader';

function TestStep({ 
  step, 
  stepIndex, 
  planId, 
  onImageUpload, 
  onUpdateStep,
  onImageClick
}) {
  if (step.step_type === 'question') return null;

  return (
    <>
      <div className="form-group">
        <label>Design Link (optional)</label>
        <input
          type="url"
          className="form-control"
          value={step.design_link || ''}
          onChange={(e) => onUpdateStep(stepIndex, 'design_link', e.target.value)}
          placeholder="https://figma.com/..."
        />
      </div>
      <div className="form-group">
        <label>UI Reference Images</label>
        <ImageUploader
          onImageUpload={(files) => onImageUpload(stepIndex, files)}
          planId={planId}
          label="📸 Click to upload reference images"
          images={step.ui_images || []}
          onImageClick={onImageClick}
        />
      </div>
    </>
  );
}

export default TestStep; 